<template>
    <Modal :modal-title="title"
           :dialog="subContractorsFormVisibility"
           max-width="600px"
           :persistent="true"
           :closeIcon="false"
           dense
           data-test="modal"
           @keydown.enter="showConfirmation"
           @keydown.esc="closeWithConfirmation"
           @close="close"
           @visibility="visibility($event)">
        <template slot="content">
            <SubContractorsForm ref="form"
                          :is-editable="isEditable">

            </SubContractorsForm>

            <ValidationError v-if="showError"></ValidationError>
        </template>
        <template slot="actions">
            <v-layout align-center
                      justify-end
                      class="mt-3">
                <v-btn color="secondary"
                       outlined
                       class="mr-3"
                       data-test="closeBtn"
                       @click="close">{{ $t('buttons.cancel') }}</v-btn>
                <v-btn color="secondary"
                       data-test="saveBtn"
                       :loading="loader"
                       :disabled="loader"
                       @click="save">{{ $t('buttons.save') }}</v-btn>
            </v-layout>
        </template>
    </Modal>
</template>

<script>
import { mapState } from 'vuex';
import Modal from '@/components/templates/Modal';
import SubContractorsForm from '@/components/subContractors/SubContractorsForm';
import ValidationError from '@/components/widgets/ValidationError';

export default {
    name: 'ManageSubContractors',
    components: { Modal, SubContractorsForm, ValidationError },
    data: () => ({
        showConfirmationDialog: false,
        loader: false,
        showError: false
    }),
    computed: {
        ...mapState('manageSubContractors', [
            'subContractorsFormVisibility',
            'subContractorsData',
            'editedSubContractorsId'
        ]),
        isFieldsDirty () {
            return this.$refs.form.isFormDirty;
        },
        title () {
            return this.isEditable ? this.$t('buttons.edit') : this.$t('buttons.add');
        },
        isEditable () {
            return this.editedSubContractorsId !== null && this.editedSubContractorsId !== undefined;
        }
    },
    methods: {
        close () {
            this.$store.commit('manageSubContractors/SET_SUBCONTRACTORS_FORM_VISIBILITY', false);
            this.$store.commit('manageSubContractors/SET_SUBCONTRACTORS_ID', null);
            this.$store.commit('manageSubContractors/RESET_SUBCONTRACTORS_DATA');
            this.$refs.form.resetValidation();
            this.$emit('fetch');
        },
        visibility (event) {
            this.$store.commit('manageSubContractors/SET_SUBCONTRACTORS_FORM_VISIBILITY', event);
        },
        closeWithConfirmation () {
            if (this.isFieldsDirty) {
                this.showConfirmationDialog = true;
            } else {
                this.close();
            }
        },
        showConfirmation () {
            if (this.isFieldsDirty) {
                this.showConfirmationDialog = true;
            }
        },
        createSubContractors () {
            this.loader = true;
            this.$refs.form.validate()
                .then(valid => {
                    this.showError = !valid;
                    if (valid) {
                        this.loader = false;
                        return this.$store.dispatch('manageSubContractors/createSubContractors')
                            .then(() => {
                                this.close();
                            })
                            .finally(() => {
                                this.$emit('fetch');
                            });
                    } else {
                        this.loader = false;
                    }
                });
        },
        updateSubContractors () {
            this.loader = true;
            this.$refs.form.validate()
                .then(valid => {
                    this.showError = !valid;
                    if (valid) {
                        this.loader = false;
                        return this.$store.dispatch('manageSubContractors/updateSubContractors')
                            .then(() => {
                                this.close();
                            })
                            .finally(() => {
                                this.$emit('fetch');
                            });
                    } else {
                        this.loader = false;
                    }
                });
        },
        save () {
            if (this.isEditable) {
                this.updateSubContractors();
            } else {
                this.createSubContractors();
            }
        }
    }
};
</script>

<style scoped>

</style>
